import { ReactElement } from 'react';

/**
 * Signature of the custom translation function returned by {@link useTranslation}.
 *
 * - When no `components` are provided, the result is a plain `string`.
 * - When `components` are provided, placeholders are replaced with React nodes
 *   and the result is an array of `ReactElement`s.
 */
export type TFunction = {
  (key: string): string;
  (key: string, values: Record<string, TFunctionValue>): string;
  (key: string, values: Record<string, TFunctionComponent>): ReactElement[];
  (
    key: string,
    values: Record<string, TFunctionValue | TFunctionComponent>,
  ): ReactElement[];
};

export type TFunctionValue = string | number | undefined | null;
export type TFunctionComponent = ReactElement;

export function isTFunctionValue(value: unknown): value is TFunctionValue {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    value === undefined ||
    value === null
  );
}
